import { render, staticRenderFns } from "./PdTabSettingModalQualityInputGroup.vue?vue&type=template&id=966410e6&scoped=true&"
import script from "./PdTabSettingModalQualityInputGroup.vue?vue&type=script&lang=ts&"
export * from "./PdTabSettingModalQualityInputGroup.vue?vue&type=script&lang=ts&"
import style0 from "./PdTabSettingModalQualityInputGroup.vue?vue&type=style&index=0&id=966410e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966410e6",
  null
  
)

export default component.exports